import { HttpContext, HttpContextToken, type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { MmscanLoadingService } from './loading.service';

/** Set on a request to keep it out of the global loading indicator (polling, typeahead). */
export const MMSCAN_SKIP_LOADING = new HttpContextToken<boolean>(() => false);

/** `http.get(url, { context: skipGlobalLoading() })` */
export function skipGlobalLoading(context = new HttpContext()): HttpContext {
  return context.set(MMSCAN_SKIP_LOADING, true);
}

/**
 * Counts in-flight HTTP requests in `MmscanLoadingService`.
 * `provideHttpClient(withInterceptors([mmscanLoadingInterceptor]))`
 */
export const mmscanLoadingInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.context.get(MMSCAN_SKIP_LOADING)) return next(request);
  const stop = inject(MmscanLoadingService).start();
  return next(request).pipe(finalize(stop));
};
